import React from 'react';
import { AlertTriangle } from 'lucide-react';

import { Callout, Message, ActionButton } from './PendencyCallout.style';

interface PendencyCalloutProps {
  message: React.ReactNode;
  actionLabel?: string;
  onAction?: () => void;
  /** Conteúdo de resolução inline (ex.: campo de valor pontual da MP no P3). */
  children?: React.ReactNode;
}

const PendencyCallout: React.FC<PendencyCalloutProps> = ({ message, actionLabel, onAction, children }) => (
  <Callout>
    <Message>
      <AlertTriangle size={14} />
      <span>{message}</span>
    </Message>
    {actionLabel && onAction && (
      <ActionButton type="button" variant="primary" onClick={onAction}>
        {actionLabel}
      </ActionButton>
    )}
    {children}
  </Callout>
);

export default PendencyCallout;
